import { render, staticRenderFns } from "./Formula.vue?vue&type=template&id=7a75c586&"
import script from "./Formula.vue?vue&type=script&lang=js&"
export * from "./Formula.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/otavio.cardoso.neto/Workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a75c586')) {
      api.createRecord('7a75c586', component.options)
    } else {
      api.reload('7a75c586', component.options)
    }
    module.hot.accept("./Formula.vue?vue&type=template&id=7a75c586&", function () {
      api.rerender('7a75c586', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/formula/Formula.vue"
export default component.exports